module.exports = __webpack_public_path__ + "images/emoji/turtle.c587ac7fb6cf741b8ca9.png";